<template>
  <div class="footer-subscribe">
    <!-- <div class="footer-subscribe-title font-15-rem-title">Meet EBO X Now!</div>
    <div class="footer-subscribe-des font-12-rem">Subscribe to receive the latest updates from Enabot.</div> -->
    <!-- <div>
      <ul class="footer-subscribe-box-ul">
        <h2 class="footer-subscribe-box-title font-15-rem-title">Sign Up to Get: </h2>
        <li class="footer-subscribe-box-li font-12-rem">Exclusive Offers</li>
        <li class="footer-subscribe-box-li font-12-rem">First-to-Know Product Info</li>
        <li class="footer-subscribe-box-li font-12-rem">Enabot Official Invitation</li>
      </ul>
      <div class="footer-subscribe-input-wrap">
        <input v-model.trim="subscribeInput" class="footer-subscribe-input" placeholder="Enter Email" type="text"><button v-preventReClick @click="SubscribeClick" class="footer-subscribe-button font-12-rem">Subscribe</button>
      </div>
    </div> -->
    <!-- <div class="footer-subscribe-tip font-12-rem">
      <input class="footer-subscribe-checkbox" type="checkbox">I agree to comply with the&nbsp; 
      <a class="footer-subscribe-a font-12-a" href="">Enabot Privacy </a>&nbsp;and&nbsp;
      <a class="footer-subscribe-a font-12-a" href="">Terms of use</a>.
    </div> -->
    <PhoneGoKS />
    <div>
      <div class="home-code-wrap">
        <img src="https://mediakit.enabot.com/eboX/img/mobile/home_code@2x.png" alt="">
      </div>
      <div class="home-button-wrap">
        <button @click="goToFacebook" class="home-button font-12-rem">Join EBO X Group</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/axios";
import PhoneGoKS from './phoneGoKS'
export default {
  props:[
    'tag'
  ],
  components: {
    PhoneGoKS
  },
  data() {
    return {
      agreeSubscribe:false,
      subscribeInput:'',
      // mailchimpAPIKey:'38cd4579f5cf300c98dcd103bd8da396-us14'
      mailchimpAPIKey:'2a2e678d6d144b8b0460a8af0ec198c5-us21'
    }
  },
  methods: {
    async SubscribeClick() {
      if(this.subscribeInput === ''){
        this.$emit('handleStatus',{status:3})
        return
      }
      if(!(/^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,14})$/.test(this.subscribeInput))){
        this.$emit('handleStatus',{status:4})
        return
      }
      axios({
        method: 'post',
        // url: `lists/685f359cf4/members`,
        url: `lists/9d085aac1d/members`,
        data: {
          email_address: this.subscribeInput,
          status: "subscribed",
          tags: this.tag || ["ebo_x_home"]
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `apikey ${this.mailchimpAPIKey}`,
        },
      })
      .then(res => {
        if(res.status === 200){
          this.$emit('handleStatus',{status:1})
          this.subscribeInput = ''
        }else{
          this.$emit('handleStatus',{status:4})
        }
        
      })
      .catch((err) => {
        if(err.response){
          if(err.response.data.title.includes('Member Exists')){
            this.$emit('handleStatus',{status:2})
          }else{
            this.$emit('handleStatus',{status:4})
          }
          
        }
      })
    },
    goToFacebook() {
      window.open("https://www.facebook.com/groups/3167832886862481")
    },
  },
}
</script>

<style lang="scss">
.footer-subscribe{
  // padding-bottom: 3.375rem;
  .footer-subscribe-title{
    margin-bottom: 0.625rem;
  }
  .footer-subscribe-des{
    opacity: 0.7;
  }
  .footer-subscribe-input-wrap{
    display: flex;
    justify-content: center;
    padding: 1.25rem 0;
  }
  .footer-subscribe-box-title{
    margin-bottom: 0.625rem;
  }
  .footer-subscribe-box-ul{
    width: 10.8rem;
    text-align: left;
    margin: 0 auto;
    .footer-subscribe-box-li{
      opacity: 0.7;
      list-style: square;
      margin-left: 1rem;
      white-space:nowrap;
    }
  }
  .footer-subscribe-input{
    width: 50%;
    // border: 1px solid #fff;
    background: #fff;
    border-radius: 0.125rem 0 0 0.125rem;
    padding: 0 0.625rem;
    box-sizing: border-box;
    font-size: 0.75rem;
    height: 1.5rem;
  }
  .footer-subscribe-button{
    background: RGBA(50, 153, 255, 1);
    background: linear-gradient(to left, #3988ff, #00fcff);
    border-radius: 0 0.125rem 0.125rem 0;
    padding: 0.125rem 0.375rem 0.165rem;
    margin-left: -0.06rem;
    border: none;
  }
  .home-code-wrap{
    text-align: center;
    padding: 2.875rem 0 0.5rem 0;
    img{
      width: 20%;
      height: auto;
      margin: 0 auto;
    }
  }
  .home-button-wrap{
    text-align: center;
    .home-button{
        background: linear-gradient(to left, #3988ff, #00fcff);
        border-radius: 1rem;
        padding: 0.375rem 0.625rem 0.425rem;
        font-weight: bold;
    }
  }
}
</style>